import React, { Component } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import { ALERT_SEVERITY } from './AlertDisplay2';

export const DAYS = {
    0: 'MONDAY',
    1: 'TUESDAY',
    2: 'WEDNESDAY',
    3: 'THURSDAY',
    4: 'FRIDAY',
    5: 'SATURDAY',
    6: 'SUNDAY',
};

const DAY_SHORTCUTS = {
    MONDAY: 'Mo',
    TUESDAY: 'Di',
    WEDNESDAY: 'Mi',
    THURSDAY: 'Do',
    FRIDAY: 'Fr',
    SATURDAY: 'Sa',
    SUNDAY: 'So',
};

class DayPickerDialog extends Component {
    constructor(props) {
        super(props);

        const initialDaySelection =
            props.daySelection !== -1
                ? props.daySelection
                : props.blockedDays?.includes(0)
                    ? -1
                    : 0;

        this.state = {
            daySelection: initialDaySelection,
        };
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.daySelection !== this.props.daySelection ||
            prevProps.open !== this.props.open
        ) {
            const initialDaySelection =
                this.props.daySelection !== -1
                    ? this.props.daySelection
                    : this.props.blockedDays?.includes(0)
                        ? -1
                        : 0;

            this.setState({
                daySelection: initialDaySelection,
            });
        }
    }

    changeDaySelection = (dayIndex) => {
        const { blockedDays = [], showAlert } = this.props;

        if (blockedDays.includes(dayIndex)) {
            showAlert?.('Dieser Wochentag kann nicht ausgewählt werden.', ALERT_SEVERITY.WARNING);
            return;
        }

        this.setState({ daySelection: dayIndex });
    };

    renderDayButton = (dayIndex) => {
        const isBlocked = this.props.blockedDays?.includes(dayIndex);
        const isSelected = this.state.daySelection === dayIndex;

        return (
            <Box
                key={dayIndex}
                onClick={() => this.changeDaySelection(dayIndex)}
                sx={{
                    borderColor: isSelected ? '#F19135' : !isBlocked ? '#CECECE' : '#E0E0E0',
                    borderWidth: isSelected ? 1.5 : 1,
                    borderStyle: 'solid',
                    borderRadius: '6px',
                    width: 60,
                    height: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: isBlocked ? 'default' : 'pointer',
                    userSelect: 'none',
                }}
            >
                <Typography
                    sx={{
                        fontSize: 13,
                        textAlign: 'center',
                        color: !isBlocked ? '#676767' : '#B0B0B0',
                    }}
                >
                    {DAY_SHORTCUTS[DAYS[dayIndex]]}
                </Typography>
            </Box>
        );
    };

    render() {
        const { open, closeDialog, setDayPickerSelection } = this.props;

        return (
            <Dialog open={open} onClose={closeDialog} maxWidth="xs" fullWidth>
                <DialogTitle>Wochentag</DialogTitle>

                <DialogContent>
                    <Box
                        sx={{
                            pt: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {this.renderDayButton(0)}
                            {this.renderDayButton(1)}
                            {this.renderDayButton(2)}
                        </Box>

                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {this.renderDayButton(3)}
                            {this.renderDayButton(4)}
                            {this.renderDayButton(5)}
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            {this.renderDayButton(6)}
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeDialog}>Abbrechen</Button>
                    <Button
                        variant="contained"
                        onClick={() => setDayPickerSelection?.(this.state.daySelection)}
                    >
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default DayPickerDialog;